import axios from 'axios';
import type { AxiosInstance } from 'axios';
import { InjectionToken } from '../../injection';

/** @internal */
export function axiosStaticHttpClientFactory(): AxiosInstance {
  return axios;
}

/** @internal */
export const AXIOS_STATIC_HTTP_CLIENT: InjectionToken<AxiosInstance>
  = new InjectionToken<AxiosInstance>('AXIOS_STATIC_HTTP_CLIENT');
